import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { formatterCreateAt, FormatterStatus, subStringText } from "components/Function";
import { ReactTable } from "components/Table";
import Loading from "components/Loading";
import { getSizePerPageList } from "helper/constant";
import DatetimePicker from "components/elements/dateTimePicker";
import SelectUser from "components/elements/selectUser";
import SelectShop from "components/elements/selectShop";
import { getListOrdersAdmin } from "actions/orderActions";
import ReactImageMagnify from "react-image-magnify";
import { Link } from "react-router-dom";

import HmLogo from "components/assets/media/logo-print/HM.jpg";
import A2kLogo from "components/assets/media/logo-print/a2k.png";
import FlashshipLogo from "components/assets/media/logo-print/flashship.svg";
import GearmentLogo from "components/assets/media/logo-print/gearment.png";
import LenfulLogo from "components/assets/media/logo-print/lenful.png";
import MangoLogo from "components/assets/media/logo-print/mangotee.png";
import OnospodLogo from "components/assets/media/logo-print/onospod.jpg";
import PrinteeshubLogo from "components/assets/media/logo-print/printeeshub.png";
import KvLogo from "components/assets/media/logo-print/kv.jpg";

const ImagePrinter = {
    hmfulfill: HmLogo,
    a2kecom: A2kLogo,
    flashship: FlashshipLogo,
    gearment: GearmentLogo,
    lenful: LenfulLogo,
    mangoteeprints: MangoLogo,
    onospod: OnospodLogo,
    printeeshub: PrinteeshubLogo,
    kvfulfill: KvLogo,
};

function AdminOrder(props) {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [filter, setFilter] = useState({});
    const [totalSize, setTotalSize] = useState(0);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(0);
    var { formatterCreateAt, getListOrdersAdmin } = props;

    useEffect(() => {
        if (Object.keys(filter).length) {
            setIsLoading(true);
            getListOrdersAdmin({ page, sizePerPage, filter }).then((data) => {
                setList(data?.list || []);
                setTotalSize(data?.totalsize || 0);
                setIsLoading(false);
            });
        }
    }, [page, sizePerPage, filter, getListOrdersAdmin]);

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "printer",
            text: "Printer",
            sort: true,
            formatter: (cell, row) => {
                return (
                    <>
                        <p><b>{cell}</b></p>
                        {ImagePrinter[cell] && (
                            <img
                                style={{
                                    width: "150px",
                                    height: "150px",
                                    objectFit: "contain",
                                    maxWidth: "100%",
                                }}
                                src={ImagePrinter[cell]}
                                alt={`Brand Logo`}
                                className="logo image-disable-drag"
                            />
                        )}
                    </>
                );
            },
        },
        {
            dataField: "count",
            text: "Count",
            sort: true,
        },
    ];

    const groupButton = () => {
        return (
            <div className="d-flex gap-2">
                <SelectUser onChange={(data) => setFilter((prev) => ({ ...prev, user: data }))} />
                <SelectShop onChange={(data) => setFilter((prev) => ({ ...prev, shop: data }))} />
                <DatetimePicker onChange={(data) => setFilter((prev) => ({ ...prev, ...data }))} />
            </div>
        );
    };

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setFilter((prev) => ({ ...prev, search: searchText }));
        } else {
            setPage(page || 1);
            setSizePerPage(sizePerPage);
        }
    };

    return (
        <Fragment>
            <Loading isLoading={isLoading} />
            <div className="card mb-5 mb-xl-10">
                <div className="card-body p-9">
                    <div className="al-variants-table">
                        <ReactTable
                            columns={columns}
                            data={list}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={getSizePerPageList(totalSize)}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    formatterCreateAt,
    FormatterStatus,
    getListOrdersAdmin,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminOrder);
